(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/game-card/footer.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/game-card/footer.js');

'use strict';

const _React = React,
  useContext = _React.useContext,
  useMemo = _React.useMemo;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const Button = svs.ui.ReactButton;
const formatCurrency = svs.utils.format.Currency;
const ContainerContext = svs.numbergames.fractiongames.contexts.ContainerContext;
const Footer = React.forwardRef((_ref, ref) => {
  let onPay = _ref.onPay;
  const _useContext = useContext(ContainerContext),
    selectors = _useContext.selectors;
  const sharePrice = useSelector(selectors.selectSharePrice);
  const btnTitle = useMemo(() => "Betala ".concat(formatCurrency(sharePrice), " kr"), [sharePrice]);
  return React.createElement("div", {
    ref: ref
  }, React.createElement(Button, {
    block: true,
    focus: true,
    inverted: true,
    onClick: onPay,
    title: btnTitle
  }, btnTitle));
});
svs.numbergames.fractiongames.components.gamecard.Footer = Footer;

 })(window);